import React from "react";
import { Button, Modal } from "rsuite";
import { TypeAttributes } from "rsuite/esm/@types/common";

export const CustomModal = ({
  okButton,
  title,
  children,
  component,
  modalSize,
  notCloseOnOk,
  className,
  onOk,
}: {
  okButton: string;
  className?:string;
  title?: string;
  component: JSX.Element;
  children: React.ReactNode;
  modalSize?: TypeAttributes.Size | undefined;
  notCloseOnOk?: boolean;
  onOk?: () => void;
}) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div className="modal-container">
      <div className= {className || "click"} onClick={handleOpen}>
        {component}
      </div>

      <Modal open={open} onClose={handleClose} size={modalSize}>
        <Modal.Header>
          {title && <Modal.Title>{title}</Modal.Title>}
        </Modal.Header>
        <Modal.Body>{children}</Modal.Body>
        <Modal.Footer>
          <div className="d-flex align-items-center justify-content-end">
          <Button onClick={handleClose} appearance="subtle" className="modal-cancel-button">
            Cancel
          </Button>
          <Button
            onClick={() => {
              onOk && onOk();
              !notCloseOnOk && handleClose();
            }}
            appearance="primary"
            className="modal-add-button"
          >
            {okButton}
          </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
